/* istanbul ignore file */
import { useArtifactStorageUrl } from 'domain/shared/artifactStorage';
import { Breadcrumbs, CreateBreadcrumbItem, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateArtifactStorageBreadcrumbs = () => {
  const { getListUrl } = useArtifactStorageUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Artifact Storage" link={getListUrl()} />
      <CreateBreadcrumbItem entity="Artifact" />
    </Breadcrumbs>
  );
};

export default CreateArtifactStorageBreadcrumbs;
